module.exports = __webpack_public_path__ + "static/media/logo-nakitbasit.c079713c.svg";